<!--audio播放器
	暂时指定src，不能动态加载
	其他页面引入后使用 this.$refs.xxxxx.playPause()进行停止/播放
-->
<template>
	<div class="audioControlBody">
		<audio src="/static/mp3/notify.wav" controls="controls" ref="music" loop hidden></audio>
	</div>
</template>

<script type="text/javascript">
	export default {
		name: 'audioControl',
		components: {},
		props: [],
		data() {
			return {
				playFlag: false
			}
		},
		created() {},
		mounted() {},
		destroyed() {},
		computed: {},
		watch: {},
		methods: {
			playWarn(){
				var audio = this.$refs.music
				audio.play()
			},
			pauseWarn(){
				var audio = this.$refs.music
				audio.pause()
				audio.currentTime = 0
			}
		}
	}
</script>

<style scoped>

</style>
